module.exports = __webpack_public_path__ + "static/media/logo-auto.c8d0ed3e.svg";